import React, { useMemo } from 'react';
import { graphql, usePaginationFragment } from 'react-relay/hooks';
import { DataTable } from '@sonika-se/ui-kit/components';
import { formatDate, toDate } from '@sonika-se/ui-kit/utils/time';
export const EventTable = (props) => {
    const { queryRef } = props;
    const { data, hasNext, loadNext } = usePaginationFragment(graphql `
      fragment EventTable_query on Query
      @argumentDefinitions(
        after: { type: "String" }
        first: { type: "Int", defaultValue: 50 }
        where: { type: "EventFilterInput" }
      )
      @refetchable(queryName: "EventTablePaginationQuery") {
        admin_events(after: $after, first: $first, order: { timestampId: DESC }, where: $where)
          @connection(key: "EventTable_query_admin_events", filters: ["where"]) {
          edges {
            node {
              id
              name
              timestampId
            }
          }
        }
      }
    `, queryRef);
    const events = useMemo(() => data.admin_events.edges.map(({ node: { name, timestampId } }) => ({
        name,
        timestampId,
    })), [data]);
    return (<DataTable columns={{
            name: {
                text: 'Namn',
            },
            timestampId: {
                render: (timestamp) => formatDate(toDate(timestamp), 'dateTime'),
                text: 'Skapad',
            },
        }} onPaginate={() => loadNext(50)} pagination={{
            buttonText: 'Ladda fler',
            hasNextPage: hasNext,
        }} rows={events}/>);
};
export default EventTable;
